import React from 'react'
import {
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Switch,
  Typography,
} from 'antd'
import { DatePickerWithMask } from '../../../../components'
import { timeZones } from '../../../../redux/constants'

const URL_WEBSOCKET = process.env.REACT_APP_EQUIPAMENTO_WEBSOCKET_URL;
const PORT_WEBSOCKET = process.env.REACT_APP_EQUIPAMENTO_WEBSOCKET_PORT;

const T4 = ({ communicationType, handleClearDateTime, handleClearTimeZones }) => {
  const [atualizar, setAtualizar] = React.useState(false)

  return (
    <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
      <Card title="Dados de comunicação">
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="numero_serial_rep"
              label="Número de série"
              hasFeedback
              rules={[{ required: true, message: 'Campo obrigatório.' }]}
            >
              <Input placeholder="Número de série" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} md={12}>
            {URL_WEBSOCKET && <div>
                <p style={{ fontWeight: 'bold' }}>URL de Conexão</p>
                <Typography.Text copyable>{URL_WEBSOCKET}</Typography.Text>
              </div>}
          </Col>
          <Col xs={24} md={12}>
            {PORT_WEBSOCKET && <div>
                <p style={{ fontWeight: 'bold' }}>Porta</p>
                <Typography.Text copyable>{PORT_WEBSOCKET}</Typography.Text>
              </div>}
          </Col>
        </Row>
      </Card>
      <Card title="Outros">
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="configuracao_t4[atualizar_data_hora]"
              label="Atualizar data e hora do relógio"
              valuePropName="checked"
            >
              <Switch
                value={atualizar}
                onChange={() => {
                  setAtualizar(!atualizar)
                  handleClearDateTime()
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <DatePickerWithMask
              label="Data e hora"
              name="configuracao_idface[data_hora]"
              showTime={true}
              disabled={!atualizar}
            />
          </Col>
          {/* <Col xs={24} md={12}>
            <Form.Item
              name="configuracao_idface[formato_rfid]"
              label="Formato RFID"
            >
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (typeof option.children === 'string'
                    ? option.children
                    : option.children.props.children
                  )
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                allowClear
                placeholder="Formato RFID"
                showSearch
              >
                <Select.Option value="decimal">Decimal</Select.Option>
                <Select.Option value="simples">
                  Simples (com virgula)
                </Select.Option>
              </Select>
            </Form.Item>
          </Col> */}
          <Col xs={24}>
            <Form.Item
              name="configuracao_t4[fuso_horario]"
              label="Fuso horário"
              hasFeedback
              rules={[{ required: true, message: 'Campo obrigatório.' }]}
            >
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (typeof option.children === 'string'
                    ? option.children
                    : option.children.props.children
                  )
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                allowClear
                placeholder="Selecione o fuso horário"
                showSearch
              >
                {timeZones.map((item) => (
                  <Select.Option value={item.value}>{item.label}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Space>
  )
}

export default T4
